import type { ApiPresignedFileUpload } from '#/api/s3File/types/ApiPresignedFileUpload';
import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import { waitTaskCompleted } from '#/utils/asyncBackendTask/waitTaskCompleted';
import { postData } from '#/utils/http/postData';

import { embedSearchWidgetApiClientFetchS3FileUploadTask } from './embedSearchWidgetApiFetchS3FileUploadTask';

type Args = {
  embedSearchWidgetId: ApiEmbedSearchWidgetId;
  file: File;
  presignedUpload: ApiPresignedFileUpload;
};

export async function embedSearchWidgetApiSendFileToS3PresignedUpload({
  embedSearchWidgetId,
  file,
  presignedUpload,
}: Args) {
  // Prepare form data
  const formData = new FormData();
  for (const [key, value] of Object.entries(presignedUpload.params.fields)) {
    formData.append(key, value);
  }
  formData.append('file', file);

  // Send file
  await postData(presignedUpload.params.url, formData);

  // Wait for file to finish uploading
  const task = await embedSearchWidgetApiClientFetchS3FileUploadTask(
    embedSearchWidgetId,
    presignedUpload.s3File.id,
  );
  await waitTaskCompleted(task);

  return presignedUpload.s3File.id;
}
